







import { Component, Vue, Prop } from "vue-property-decorator";
const namespace: string = "authentication";
var scroll: any;

@Component({
    directives: {
        abg: {
            inserted: function (element, binding, vnode) {
                var offset = (window.pageYOffset + element.getBoundingClientRect().top) - 160; // 160 is the height of the topbar
                scroll = function () {
                    var doc = document.documentElement;
                    var top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
                    if (top >= offset) (vnode.context as any).sticky = true;
                    else (vnode.context as any).sticky = false;
                };
                window.addEventListener("scroll", scroll, false);
            },
            unbind: function (element, binding, vnode) {
                window.removeEventListener("scroll", scroll, false);
            }
        }
    }
})
export default class HeaderActionButtons extends Vue {
    @Prop() back!: Function;
    @Prop() save!: Function;

    // local

    sticky = false;
}
